import { apiClient } from '@/lib/api-client';
import { LoginResponse, CurrentUserResponse } from '../types';

interface LoginRequest {
    username: string;
    password: string;
}

interface RegisterRequest {
    email: string;
    password: string;
    shopName: string;
}

interface ChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}

export const authApi = {
    login: async (data: LoginRequest): Promise<LoginResponse> => {
        const response = await apiClient.post('/auth/login', data);
        return response.data;
    },

    register: async (data: RegisterRequest): Promise<LoginResponse> => {
        const response = await apiClient.post('/auth/register', data);
        return response.data;
    },

    getMe: async (): Promise<CurrentUserResponse> => {
        const response = await apiClient.get('/auth/me');
        return response.data;
    },

    changePassword: async (data: ChangePasswordRequest): Promise<void> => {
        await apiClient.post('/auth/change-password', data);
    },
};
